import { defineMessages } from 'react-intl';

const messages = defineMessages({
  reInventTitle: {
    id: 'landingPage.reInvent',
    defaultMessage:
      'Welcome to <b>AWS\u00a0Builder\u00a0Labs</b> at re:Invent\u00a02023', // \u00a0 is the unicode representation of html entity - nbsp
  },
  reInventMessage: {
    id: 'landingPage.reInventMessage',
    defaultMessage: 'Sign in to build real skills in a live lab environment',
  },
});

export default messages;
